import generalConfig from './general';

export const apiConfig = {
  apiUrl: generalConfig.apiUrl,
  localUrl: 'http://192.168.1.4:3030',
  slackUrl: 'https://hooks.slack.com/services/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',
  baseUrl: process.env.REACT_APP_API_URL || 'http://10.0.0.137:3030',
  apiTimeout: 20000,
};
